import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useView } from "../../context/ViewContext";
import { logoutSession } from "../../utils/auth";
import "./AdminNavbar.css";

const AdminNavbar = () => {
  const navigate = useNavigate();
  const { setCurrentView } = useView();
  const linkClassName = ({ isActive }) =>
    `admin-navbar__link${isActive ? " admin-navbar__link--active" : ""}`;
  const handleLogout = async () => {
    await logoutSession();
    setCurrentView("customer");
    navigate("/login");
  };

  return (
    <header className="admin-navbar">
      <div className="admin-navbar__brand">Haastia Admin</div>
      <div className="admin-navbar__controls">
        <nav className="admin-navbar__links" aria-label="Admin navigation">
          <NavLink to="/admin" className={linkClassName} end>
            Dashboard
          </NavLink>
          <NavLink to="/calendar" className={linkClassName}>
            Professional dashboard
          </NavLink>
          <NavLink to="/admin/recruiters" className={linkClassName}>
            Recruiters
          </NavLink>
          <NavLink to="/admin/founding-referrals" className={linkClassName}>
            Founding referrals
          </NavLink>
          <NavLink to="/admin/trial-coupons" className={linkClassName}>
            Trial coupons
          </NavLink>
          <NavLink to="/admin/discovery-applications" className={linkClassName}>
            Discovery applications
          </NavLink>
          <NavLink to="/admin/support-tickets" className={linkClassName}>
            Support tickets
          </NavLink>
        </nav>
        <button
          type="button"
          className="admin-navbar__logout"
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>
    </header>
  );
};

export default AdminNavbar;
